import { useEffect } from "react";
import type { SSEEventType } from "@egalregal/shared";
import { subscribeSSE, type SSEPayload } from "./events";

/**
 * Subscribe to a global SSE event from a React component.
 * Cleans up automatically on unmount.
 */
export function useSSEEvent(
  type: SSEEventType,
  handler: (data: SSEPayload) => void,
): void {
  useEffect(() => subscribeSSE(type, handler), [type, handler]);
}
